import * as authentication from "../../common/actions/authentication";
import * as history from "../actions/history.js";

import Immutable from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        documents: {
            isLoading: false,
            allResultsLoaded: false,
            filter: {
                historyType: history.HISTORY_TYPES.ALL,
                searchString: ""
            },
            results: [],
        },
        tobacco: {
            loading: false,
            submitting: false,
            trySubmit: false,
            pickUpByEngrospartner: null,
            description: "",
            bagSupplier: [],
            unconfirmedComplaintId: null,
            sentToEp: false,
        },
        tobaccoDocuments: {
            isLoading: false,
            allResultsLoaded: false,
            filter: {
                searchString: ""
            },
            results: [],
        },
        lastInvoiceForProduct: {},
        claim: {
            claim: true,
            committing: false,
            description: "",
            lines: [],
            attachments: [],
        },
        invoices: {},
    });
};

/**
 * View reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function(state = defaultState(), action) {
    switch(action.type) {
    case history.EDIT_DOCUMENT_HISTORY_QUERY:
        return Immutable.merge(state, {
            documents: {
                ...action.change
            }
        }, {
            deep: true
        });
    case history.ADD_DOCUMENTS_HISTORY_QUERY_RESULTS:
        return Immutable.setIn(state, ["documents", "results"], state.documents.results.concat(action.results));
    case history.CLEAR_DOCUMENTS_HISTORY_QUERY_RESULTS:
        return Immutable.setIn(state, ["documents", "results"], []);
    case history.ADD_TOBACCO_BAG:
    {
        const supplierIndex = state.tobacco.bagSupplier.findIndex( (ele) => ele.supplierId === action.supplierId );
        if( supplierIndex>=0 ) {
            return Immutable.setIn(state, ["tobacco", "bagSupplier", supplierIndex, "bags"], state.tobacco.bagSupplier[supplierIndex].bags.concat({
                bagNumber: action.bagNumber,
                bagNumberValidated: action.bagNumberValidated,
                bagNumberEditable: action.bagNumberEditable,
                lines: []
            }));
        } else {
            return Immutable.setIn(state, ["tobacco", "bagSupplier"], state.tobacco.bagSupplier.concat({
                supplierName: action.supplierName,
                supplierId: action.supplierId,
                bags: [{
                    bagNumber: action.bagNumber,
                    bagNumberValidated: action.bagNumberValidated,
                    bagNumberEditable: action.bagNumberEditable,
                    lines: [],
                }]
            }));
        }
    }
    case history.EDIT_TOBACCO_BAG:
    {
        const supplierIndex = state.tobacco.bagSupplier.findIndex( (ele) => ele.supplierId === action.supplierId );
        
        return Immutable.setIn(state, ["tobacco", "bagSupplier", supplierIndex, "bags", action.bagIndex], {
            ...state.tobacco.bagSupplier[supplierIndex].bags[action.bagIndex],
            ...action.change
        });
    }
    case history.ADD_ITEM_TO_TOBACCO_BAG:
    {
        const supplierIndex = state.tobacco.bagSupplier.findIndex( (ele) => ele.supplierId === action.product.supplierId );
        const bagIndex = state.tobacco.bagSupplier[supplierIndex].bags.length-1;
        
        if( state.tobacco.bagSupplier[supplierIndex].bags[bagIndex].lines.some( (ele) => ele.product.productId===action.product.productId) ){
            return Immutable.setIn(state, ["tobacco", "bagSupplier", supplierIndex, "bags", bagIndex, "lines"], state.tobacco.bagSupplier[supplierIndex].bags[bagIndex].lines.map( (ele) => ele.product.productId!==action.product.productId ? ele : {
                product: action.product,
                wishedQtySalesUnits: action.value, 
            }));
        } else {
            return Immutable.setIn(state, ["tobacco", "bagSupplier", supplierIndex, "bags", bagIndex, "lines"], state.tobacco.bagSupplier[supplierIndex].bags[bagIndex].lines.concat({
                product: action.product,
                wishedQtySalesUnits: action.value,
            }));
        }
    }
    case history.REMOVE_ITEM_FROM_TOBACCO_BAG:
    {
        const supplierIndex = state.tobacco.bagSupplier.findIndex( (ele) => ele.supplierId === action.product.supplierId );
        const supplierToChange = state.tobacco.bagSupplier[supplierIndex];
        const bagIndex = supplierToChange.bags.length-1;
        const bagToChange = supplierToChange.bags[bagIndex];

        const newLines = bagToChange.lines.filter( (ele) => ele.product.productId!==action.product.productId );

        if(newLines.length > 0 || bagToChange.bagNumber !== "")
            return Immutable.setIn(state, ["tobacco", "bagSupplier", supplierIndex, "bags", bagIndex, "lines"], newLines);
        else {

            // bag is empty - and no bag number is given: remove it from state if no bag number is given
            const newBags = supplierToChange.bags.filter(bag => bag!==bagToChange);
                       
            if(newBags.length > 0) {
                return Immutable.setIn(state, ["tobacco", "bagSupplier", supplierIndex, "bags"], newBags);
            }
            else {
                // If last bag for supplier remove supplier as well
                const newSuppliers = state.tobacco.bagSupplier.filter(sup => sup!==supplierToChange);
                return Immutable.setIn(state, ["tobacco", "bagSupplier"], newSuppliers);
            }
            
        }
    }
    case history.EDIT_TOBACCO:
        return Immutable.merge(state, {
            tobacco: {
                ...action.change
            }
        }, {
            deep: true
        });
    case history.ADD_SAVEDTOBACCO_RETURN_RESULTS:
        return Immutable.setIn(state,  ["tobacco"], {
            description: action.result.description,
            pickUpByEngrospartner: action.result.pickUpByEngrospartner,
            unconfirmedComplaintId:  action.result.unconfirmedComplaintId,
            sentToEP: action.result.sentToEP,
            bagSupplier: action.result.suppliers,
            suppliers: state.tobacco.suppliers,
        });
    case history.SET_TOBACCO_UNCONFIRMEDCOMPLAINTID:
        return Immutable.setIn(state,  ["tobacco", "unconfirmedComplaintId"], action.unconfirmedComplaintId);
    case history.CLEAR_SUPPLIER:
        return Immutable.setIn(state, ["tobacco", "bagSupplier"], state.tobacco.bagSupplier.filter( (ele) => ele.supplierId !== action.supplierId));
    case history.ADD_INVOICE_ID_TO_LIST:
        return Immutable.setIn(state, ["lastInvoiceForProduct",action.productId], action.invoiceId);
    case history.CLEAR_CLAIM:
        return Immutable.setIn(state, ["claim"], {
            claim: true,
            committing: false,
            description: "",
            lines: [],
            attachments: [],
        });
    case history.ADD_TO_CLAIM_SALES_UNITS:
    {
        const index = state.claim.lines.findIndex( (item) => item.product.productId === action.product.productId );
        if( index>=0 ) {
            if( state.claim.lines[index].claimQtySalesUnits==0 && state.claim.lines[index].claimQtyWarehouseUnits==0 && action.qty===0)
            {
                return Immutable.setIn(state, ["claim", "lines"], state.claim.lines.filter( (ele) => ele.product.productId!==action.product.productId ));
            }
            return Immutable.setIn(state, ["claim", "lines", index], ({
                ...state.claim.lines[index],
                product: action.product,
                claimQtySalesUnits: action.qty,
            }));
        } else {
            return Immutable.setIn(state, ["claim", "lines"], state.claim.lines.concat({
                product: action.product,
                claimQtySalesUnits: action.qty,
                claimQtyWarehouseUnits: 0,
            }));
        }
    }
    case history.REMOVE_FROM_CLAIM_SALES_UNITS:
    {
        const index = state.claim.lines.findIndex( (item) => item.product.productId === action.product.productId );
        if( state.claim.lines[index].claimQtyWarehouseUnits==0 ){
            return Immutable.setIn(state, ["claim", "lines"], state.claim.lines.filter( (ele) => ele.product.productId!==action.product.productId ));
        } else {
            return Immutable.setIn(state, ["claim", "lines", index], ({
                ...state.claim.lines[index],
                product: action.product,
                claimQtySalesUnits: 0,
            }));
        }
    }
    case history.ADD_TO_CLAIM_WAREHOUSE_UNITS:
    {
        const index = state.claim.lines.findIndex( (item) => item.product.productId === action.product.productId );
        if( index>=0 ) {

            if( state.claim.lines[index].claimQtySalesUnits==0 && state.claim.lines[index].claimQtyWarehouseUnits==0 && action.qty===0)
            {
                return Immutable.setIn(state, ["claim", "lines"], state.claim.lines.filter( (ele) => ele.product.productId!==action.product.productId ));
            }
            return Immutable.setIn(state, ["claim", "lines", index], ({
                ...state.claim.lines[index],
                product: action.product,
                claimQtyWarehouseUnits: action.qty,
            }));
        } else {
            return Immutable.setIn(state, ["claim", "lines"], state.claim.lines.concat({
                product: action.product,
                claimQtyWarehouseUnits: action.qty,
                claimQtySalesUnits: 0,
            }));
        }
    }
    case history.REMOVE_FROM_CLAIM_WAREHOUSE_UNITS:
    {
        const index = state.claim.lines.findIndex( (item) => item.product.productId === action.product.productId );
        if( state.claim.lines[index].claimQtySalesUnits==0){
            return Immutable.setIn(state, ["claim", "lines"], state.claim.lines.filter( (ele) => ele.product.productId!==action.product.productId ));
        } else {
            return Immutable.setIn(state, ["claim", "lines", index], ({
                ...state.claim.lines[index],
                product: action.product,
                claimQtyWarehouseUnits: 0,
            }));
        }
    }
    case history.EDIT_CLAIM:
        return Immutable.setIn(state, ["claim"], {
            ...state.claim,
            ...action.change,
        });
    case history.EDIT_CLAIM_ITEM:
    {
        const index = state.claim.lines.findIndex( (item) => item.product.productId === action.productId );
        if( index>=0 ) {
            return Immutable.setIn(state, ["claim", "lines", index], ({
                ...state.claim.lines[index],
                ...action.change,
            }));
        }
        return state;
    }
    case history.SET_INVOICE_DETAILS:
        return Immutable.setIn(state, ["invoices",action.invoiceId], action.invoice);
    case history.EDIT_TOBACCO_DOCUMENTS_HISTORY_QUERY:
        return Immutable.merge(state, {
            tobaccoDocuments: {
                ...action.change
            }
        }, {
            deep: true
        });
    case history.ADD_TOBACCO_DOCUMENTS_HISTORY_RESULTS:
        return Immutable.setIn(state, ["tobaccoDocuments", "results"], state.tobaccoDocuments.results.concat(action.results));
    case history.CLEAR_TOBACCO_DOCUMENTS_HISTORY_RESULTS:
        return Immutable.setIn(state, ["tobaccoDocuments", "results"], []);
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}